import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience'
import ArcadeWorld from './ArcadeWorld'
import * as THREE from 'three'
import Floor from './Floor'
import { PresentationControls } from '@react-three/drei'
import GoBack from './GoBack'
import { Loader } from '@react-three/drei'
import InsertCoin from './InsertCoin'
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
import { useManosStore } from './hooks'
import ReactAudioPlayer from 'react-audio-player'
import { IconButton, Typography } from '@mui/material'
import { PlayArrow, StopRounded } from '@mui/icons-material'
import useSound from 'use-sound'
import { Stack } from '@mui/system'
import {isMobile} from 'react-device-detect';
import GridFloor from './GridFloor'
import BackgroundShader from './BackgroundShader'


const Playit = ({ pauseMusic }) => {
    const bgMusic = '/assets/sounds/hero-80s-127027.mp3';
    const [play, { stop, sound, duration}] = useSound(bgMusic, { volume: 0.55,playbackRate:0.8 })
    const [isPlaying, setIsPlaying] = useState(false)
        
    useMemo(() => {
        if (pauseMusic) {
            sound?.fade(1, 0, 1000)
        }
        else {
            sound?.fade(0, 1, 1000)
        }
    }, [pauseMusic])
    
    const handleMusic = useCallback(() => {
        if (!pauseMusic) {
            if (isPlaying) {
                stop()
            }
            else {
                play({playbackRate:0.8})
                sound?.fade(0, 1, 1000)
            }
            setIsPlaying(!isPlaying)
        }
    }, [pauseMusic,sound,isPlaying])

    useEffect(()=>{
        if (duration)
        {
            play()
            setIsPlaying(true)
        }
    },[duration])


    return <>
    <div style={{ position: 'absolute', top: 10, right: 25, zIndex: 9000 }}>
        <Stack direction={'row'} alignItems={'center'}>
            <Typography style={{ cursor: (pauseMusic || !duration)? 'not-allowed': 'pointer',opacity:(pauseMusic || !duration)?0:1 }} onClick={handleMusic} variant='caption' color={'secondary'}>{isPlaying ? 'Stop' : 'Play'} Music</Typography>
            <IconButton disabled={pauseMusic || !duration} color='secondary' size='small' onClick={handleMusic}>
                {isPlaying ? <StopRounded /> : <PlayArrow />}
            </IconButton>
        </Stack>
    </div>;
        {!isMobile &&
            <div style={{position:'absolute',right:10,bottom:10}}>
                {!pauseMusic && <Typography variant='caption' sx={{color:'grey',fontStyle:'unset'}}>Music by <a style={{color:'grey',textTransform:'unset',fontStyle:'unset'}} href="https://pixabay.com/el/users/alexiaction-26977400/?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=music&amp;utm_content=127027">AlexiAction</a> from <a  style={{color:'grey',textTransform:'unset',fontStyle:'unset'}} href="https://pixabay.com/music//?utm_source=link-attribution&amp;utm_medium=referral&amp;utm_campaign=music&amp;utm_content=127027">Pixabay</a></Typography>}
            </div>
        }
    </>
};

const App = () => {
    const { zoomArcade, setCloseArcade, setInstructionsClosed } = useManosStore()
    const cameraPosition = isMobile ? [-2.5, Math.PI * 2, 22] : [-2.5, Math.PI * 2, 17]


    return (
        <>
            <Playit pauseMusic={zoomArcade} />
            <GoBack isMobile={isMobile}/>
            <Canvas
                dpr={[1, 2]}
                gl={{
                    antialias: true,
                }}

                camera={{
                    fov: isMobile?80:45,
                    near: 0.2,
                    far: 100,
                    position: cameraPosition,
                    rotation: [-0.25, - Math.PI / 34, -0.05]
                }}
            >
                <PresentationControls
                    snap
                    global
                    zoom={1.8}
                    cursor={false}
                    rotation={[0, -Math.PI / 4, 0]}
                    polar={[0, Math.PI / 4]}
                    azimuth={[-Math.PI / 4, Math.PI / 4]}>
                    <Experience />
                    <InsertCoin isMobile={isMobile}/>
                    <ArcadeWorld />
                    <Floor />
                    <GridFloor/>
                    <BackgroundShader/>
                </PresentationControls>
            </Canvas>
            <Loader />
        </>
    )
}

export default App